import React from "react";
import ReactExport from "react-export-excel";
import { currencyNumberFormat } from '../services/excelService';

import L from '../services/localizationService';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class DashboardExcelExport extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: null
        }
    }

    render() {
        if (!this.props.data || this.props.data.loadingData) return null;

        let borderColor = 'ffffffff';
        let greyFillColor = 'ffdcdcdc';
        let yellowFillColor = 'ffffff99';

        let greyFill = {patternType: 'solid', fgColor: {rgb: greyFillColor}};
        
        let fullBorderThin = { 
            top: { style: 'thin', color: borderColor},
            bottom: { style: 'thin', color: borderColor},
            left: { style: 'thin', color: borderColor},
            right: { style: 'thin', color: borderColor},
        };

        let bottomBorder = { 
            bottom: { style: 'thick', color: borderColor},
        };

        let bottomBorderThin = { 
            bottom: { style: 'thin', color: borderColor},
        };

        let topBorder = { 
            top: { style: 'thick', color: borderColor},
        };

        let fillStyleYellow = { border: fullBorderThin, fill: {patternType: 'solid', fgColor: {rgb: yellowFillColor}}};
        let fillStyle = { numFmt: currencyNumberFormat, 
            fill: {...greyFill},
            border: { 
                top: { style: 'thin', color: borderColor},
                bottom: { style: 'thin', color: borderColor},
                left: { style: 'thin', color: borderColor},
                right: { style: 'thin', color: borderColor},
            }
        };

        let data = Object.assign({}, this.props.data);

        let forecastStartMonth = data.billingsForecastStartMonth;

        let headerStyle = {alignment: { horizontal: 'center' }, font: {bold: true}};
        let dataSet = [
            {
                columnwidths: [18, 25, 21.14, 12.71, 12.71, 13.57, 12, 12.29, 12.29],
                columns: ['', '', '', '', '', '', '', ''],
                data: [
                    [
                        { value: 'PROJECT:', style: {font: {bold: true}} },
                        { value: data.project.ProjDesc },
                    ],
                    [
                        { value: 'PROJECT #:', style: {font: {bold: true}} },
                        { value: data.project.ProjNum.trim(), style: { numFmt: currencyNumberFormat }},
                        { value: '' },
                        { value: '' },
                        { value: '' },
                        { value: null },
                        { value: 'FORECAST DATE:', style: {font: {bold: true}, alignment: { horizontal: 'right'}} },
                        { value: data.forecastDate },
                    ],
                    [
                        { value: 'PROJ. MGR.:', style: {font: {bold: true}, border: bottomBorder} },
                        { value: data.project.ProjMgr || '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                        { value: this.props.data.applyExchangeRate ? 'MXN RATE:' : '', style: {font: {bold: true}, alignment: { horizontal: 'right'}, border: bottomBorder} },
                        { value: this.props.data.applyExchangeRate ? this.props.data.exchangeRate : '', style: { border: bottomBorder} },
                        { value: '', style: { border: bottomBorder} },
                    ],
                    [
                        { value: 'LINE CODE', style: headerStyle },
                        { value: '', style: headerStyle },
                        { value: 'REVISED', style: headerStyle },
                        { value: '', style: headerStyle },
                        { value: '', style: headerStyle },
                        { value: 'TOTAL', style: headerStyle },
                        { value: 'AMOUNT', style: headerStyle },
                        { value: 'ESTIMATED', style: headerStyle },
                        { value: 'ET', style: headerStyle },
                    ],
                    [
                        { value: 'SERIES', style: headerStyle },
                        { value: 'DESCRIPTION', style: headerStyle },
                        { value: 'ET', style: headerStyle },
                        { value: 'W.I.P.', style: headerStyle },
                        { value: 'OPNR', style: headerStyle },
                        { value: 'COMMITTED', style: headerStyle },
                        { value: 'TO SPEND', style: headerStyle },
                        { value: 'FINAL COST', style: headerStyle },
                        { value: 'VARIANCE', style: headerStyle },
                    ],
                ]
            }
        ];

        data.categories.forEach((item, index) => {
            let values = [];

            values.push({ value: `${index}00 SERIES`, style : {alignment: { horizontal: 'center' }, ...fillStyle}});
            values.push({ value: item.name, style : fillStyle});
            values.push({ value: L.toExcelCurrencyString(item.totals.ETAmount), style : fillStyle});
            values.push({ value: L.toExcelCurrencyString(item.totals.actualCost), style: { numFmt: currencyNumberFormat, border: fullBorderThin}});
            values.push({ value: L.toExcelCurrencyString(item.totals.opnr), style: { numFmt: currencyNumberFormat, border: fullBorderThin}});
            values.push({ value: L.toExcelCurrencyString(item.totals.committedCost), style : fillStyle});
            values.push({ value: L.toExcelCurrencyString(item.totals.amountToSpend), style : fillStyle});
            values.push({ value: L.toExcelCurrencyString(item.totals.estimatedFinalCost), style : fillStyle});
            values.push({ value: L.toExcelCurrencyString(item.totals.ETVariance), style : fillStyle});

            dataSet[0].data.push(values);

            let blankRow = [];
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyleYellow });
            blankRow.push({ value: '', style: fillStyleYellow });
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyle });
            blankRow.push({ value: '', style: fillStyle });
            dataSet[0].data.push(blankRow);
        })

        let data2 = [
            [
                { value: '', style: fillStyle },
                { value: 'TOTALS', style : {alignment: { horizontal: 'right' }, font: {bold: true}, ...fillStyle}},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.ETAmount), style : fillStyle},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.actualCost), style: { numFmt: currencyNumberFormat}},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.opnr), style: { numFmt: currencyNumberFormat }},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.committedCost), style : fillStyle},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.amountToSpend), style : fillStyle},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.estimatedFinalCost), style : fillStyle},
                { value: L.toExcelCurrencyString(data.projectCostDetailTotals.ETVariance), style : fillStyle},
            ],
            [
                { value: '', style: { border: topBorder }},
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
                { value: '', style: { border: topBorder } },
            ],
            [
                { value: 'ORIGINAL P.O.', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.originalpo), style: { fill: greyFill, numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: 'INVOICED TO DATE - NET', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.billingsTotals.invoicedToDateGross), style: { numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null  },
            ],
            [
                { value: 'C.O. $ RECVD', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.corecvd), style: { numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: 'PAID TO DATE', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.billingsTotals.paidToDate), style: { numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null  },
            ],
            [
                { value: 'TOTAL P.O.', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.totalpo), style: { fill: greyFill, numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: 'TOTAL AMOUNT UNPAID', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.billingsTotals.totalAmountUnpaid), style: { numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: null  },
            ],
            [
                { value: 'C.O. $ TO COME', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.cotocome), style: { numFmt: currencyNumberFormat, border: bottomBorderThin }},
                { value: data.meetingTitle || 'PREV MONTH', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: { left: { style: 'thick', color: borderColor}, top: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: 'CHANGE', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: { right: { style: 'thick', color: borderColor}, top: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: 'TOTAL CONTRACT', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: '=B31+B32', style: { numFmt: currencyNumberFormat, fill: greyFill, font: {bold: true}, border: bottomBorderThin }},
                { value: L.toExcelCurrencyString(data.meetingTotalContract), style: { numFmt: currencyNumberFormat, border: { left: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: '=B33-C33', style: { numFmt: currencyNumberFormat, fill: greyFill, border: { right: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: data.revenueFromTitle ? data.revenueFromTitle : 'REVENUE FROM', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: L.toExcelCurrencyString(data.revenueFrom), style: { numFmt: currencyNumberFormat, font: {bold: true}, border: bottomBorderThin }},
                { value: '', style: { numFmt: currencyNumberFormat, font: {bold: true}, fill: greyFill, border: { left: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: '', style: { numFmt: currencyNumberFormat, fill: greyFill, border: { right: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: 'EST. GP US', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: '=(B33+B34)-H27', style: { numFmt: currencyNumberFormat, fill: greyFill, font: {bold: true}, border: bottomBorderThin }},
                { value: L.toExcelCurrencyString(data.meetingEstGP), style: { numFmt: currencyNumberFormat, font: {bold: true}, fill: greyFill, border: { left: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: '=B35-C35', style: { numFmt: currencyNumberFormat, fill: greyFill, border: { right: { style: 'thick', color: borderColor}, bottom: { style: 'thin', color: borderColor}}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: 'EST GP %', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: data.estgppct ? (data.estgppct / 100) : 0, style: { alignment: { horizontal: 'right' }, numFmt: '0%', fill: greyFill, border: bottomBorderThin }},
                { value: data.meetingEstGPPct ? (data.meetingEstGPPct / 100) : 0, style: { alignment: { horizontal: 'right' }, numFmt: '0%', fill: greyFill, border: { left: { style: 'thick', color: borderColor}, bottom: { style: 'thick', color: borderColor}}}},
                { value: '=B36-C36', style: { alignment: { horizontal: 'right' }, numFmt: '0%', fill: greyFill, border: { right: { style: 'thick', color: borderColor}, bottom: { style: 'thick', color: borderColor}}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: 'REVIEW NOTES: 1)', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: 'REVIEW NOTES: 2)', style: {alignment: { horizontal: 'right' }, font: {bold: true}}},
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
                { value: null },
            ],
            [
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: 'BILLINGS FORECAST', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
            ],
            [
                { value: 'INVOICED TO DATE', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: 'REMAINING TO BILL', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
                { value: '', style: {alignment: { horizontal: 'center' }, font: {bold: true}}},
            ],
            [
                { value: 'NET', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: (data.billingsForecast.retentionPct / 100), style: {alignment: { horizontal: 'center' }, numFmt: '0.0%', border: bottomBorderThin}},
                { value: forecastStartMonth.format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
            ],
            [
                { value: L.parseFloatWithZero(data.billingsForecast.invoicedToDateNet), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.remainingToBillGross), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine0_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine1_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine2_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine3_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine4_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine5_0), style: { numFmt: currencyNumberFormat }},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine6_0), style: { numFmt: currencyNumberFormat }},
            ],
            [
                { value: '' },
                { value: '' },
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: forecastStartMonth.add(1, 'month').format('MMM-YY'), style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
                { value: 'BALANCE', style: {alignment: { horizontal: 'center' }, font: {bold: true}, border: bottomBorderThin}},
            ],
            [
                { value: '' },
                { value: '' },
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine7_0), style: { numFmt: currencyNumberFormat}},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine8_0), style: { numFmt: currencyNumberFormat}},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine9_0), style: { numFmt: currencyNumberFormat}},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine10_0), style: { numFmt: currencyNumberFormat}},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine11_0), style: { numFmt: currencyNumberFormat}},
                { value: L.parseFloatWithZero(data.billingsForecast.forecastLines.forecastLine12_0), style: { numFmt: currencyNumberFormat}},
                { value: '=B43 - (SUM(C43:I43) + SUM(C45:H44))', style: { numFmt: currencyNumberFormat, fill: greyFill}},
            ],
        ]

        dataSet[0].data.push(...data2);

        return (
            <ExcelFile hideElement filename="PM Dashboard">
                <ExcelSheet dataSet={dataSet} name="CONTRACT SUMMARY" scale="68" orientation="landscape" />
            </ExcelFile>
        );
    }
}

export default DashboardExcelExport;
